import { Text } from '@etg/wings';
import { CartRow, Price } from './CartComponents';

export interface CartSelfTransferProps {
  header: string;
  label: string;
  includedText: string;
  productName: string;
  link: string;
}

const CartSelfTransfer = (props: CartSelfTransferProps) => {
  const { header, label, includedText, productName, link } = props;
  const dataTestId = `cart-${productName}`;

  return (
    <div data-testid={`${dataTestId}-container`}>
      <Text as="p" data-testid={`${dataTestId}-header`} variant="16-bold">
        {header}
      </Text>
      <CartRow>
        <a data-testid={`${dataTestId}-link`} href={`/rf/${link}`} rel="noreferrer" target="_blank">
          {label}
        </a>
        <Price data-testid={`${dataTestId}-included-text`} isDiscount>
          {includedText}
        </Price>
      </CartRow>
    </div>
  );
};

export default CartSelfTransfer;
